module.exports = __webpack_public_path__ + "static/img/14.aaf3eb9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/sp/14.png
// module id = lCHz
// module chunks = 0